import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message } from 'element-ui'
import authService from '@/services/authService'
import Dashboard from '../views/Dashboard.vue'
import ConnectAgent from '../views/ConnectAgent.vue'
import StreamerAgent from '../views/StreamerAgent.vue'
import OperationAgent from '../views/OperationAgent.vue'
import PublishAgent from '../views/PublishAgent.vue'
import Streamers from '../views/Streamers.vue'
import Live from '../views/Live.vue'
import Content from '../views/Content.vue'
import Finance from '../views/Finance.vue'
import AiAssistant from '../views/AiAssistant.vue'
import Analytics from '../views/Analytics.vue'
import Schedule from '../views/Schedule.vue'
import CreatorLead from '../views/CreatorLead.vue'
import CreatorDetail from '../views/CreatorDetail.vue'
import HeadAgent from '../views/HeadAgent.vue'
import HeadFlow from '../views/HeadFlow.vue'
import StreamerWorkbench from '../views/StreamerWorkbench.vue'
import StreamerDetail from '../views/StreamerDetail.vue'
import StreamerStats from '../views/StreamerStats.vue'
import OperationWorkbench from '../views/OperationWorkbench.vue'
import VideoWorkbench from '../views/VideoWorkbench.vue'
import ClueManagement from '@/views/ClueManagement.vue'
import AgentChat from '@/views/AgentChat.vue'
import RecruitmentAgent from '@/views/RecruitmentAgent.vue'
import CreatorBindingManagement from '@/views/CreatorBindingManagement.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/connect-agent',
    name: 'ConnectAgent',
    component: ConnectAgent,
    meta: { requiresAuth: true }
  },
  {
    path: '/streamer-agent',
    name: 'StreamerAgent',
    component: StreamerAgent,
    meta: { requiresAuth: true }
  },
  {
    path: '/operation-agent',
    name: 'OperationAgent',
    component: OperationAgent,
    meta: { requiresAuth: true }
  },
  {
    path: '/creator-binding-management',
    name: 'CreatorBindingManagement',
    component: CreatorBindingManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/publish-agent',
    name: 'PublishAgent',
    component: PublishAgent,
    meta: { requiresAuth: true }
  },
  {
    path: '/streamers',
    name: 'Streamers',
    component: Streamers,
    meta: { requiresAuth: true }
  },
  {
    path: '/live',
    name: 'Live',
    component: Live,
    meta: { requiresAuth: true }
  },
  {
    path: '/content',
    name: 'Content',
    component: Content,
    meta: { requiresAuth: true }
  },
  {
    path: '/finance',
    name: 'Finance',
    component: Finance,
    meta: { requiresAuth: true }
  },
  {
    path: '/ai-assistant',
    name: 'AiAssistant',
    component: AiAssistant,
    meta: { requiresAuth: true }
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics,
    meta: { requiresAuth: true }
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: Schedule,
    meta: { requiresAuth: true }
  },
  {
    path: '/creator-lead',
    name: 'CreatorLead',
    component: CreatorLead,
    meta: { requiresAuth: true }
  },
  {
    path: '/creator-detail/:id',
    name: 'CreatorDetail',
    component: CreatorDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/highlight-moments/:creatorId/:sessionId',
    name: 'HighlightMoments',
    component: () => import('@/views/HighlightMoments.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/head-agent',
    name: 'HeadAgent',
    component: HeadAgent,
    meta: { requiresAuth: true }
  },
  {
    path: '/head-flow',
    name: 'HeadFlow',
    component: HeadFlow,
    meta: { requiresAuth: true }
  },
  {
    path: '/streamer-workbench',
    name: 'StreamerWorkbench',
    component: StreamerWorkbench,
    meta: { requiresAuth: true }
  },
  {
    path: '/streamer-detail/:id',
    name: 'StreamerDetail',
    component: StreamerDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/streamer-stats/:id',
    name: 'StreamerStats',
    component: StreamerStats,
    meta: { 
      requiresAuth: false,
      hideHeader: true  // 隐藏页头
    }
  },
  {
    path: '/operation-workbench',
    name: 'OperationWorkbench',
    component: OperationWorkbench,
    meta: { requiresAuth: true }
  },
  {
    path: '/video-workbench',
    name: 'VideoWorkbench',
    component: VideoWorkbench,
    meta: { requiresAuth: true }
  },
  {
    path: '/clue-management',
    name: 'ClueManagement',
    component: ClueManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/agent-chat',
    name: 'AgentChat',
    component: AgentChat,
    meta: { requiresAuth: true }
  },
  {
    path: '/recruitment-agent',
    name: 'RecruitmentAgent',
    component: RecruitmentAgent,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 开发环境：如果未启用角色测试，跳过认证检查
  if (process.env.NODE_ENV === 'development') {
    const isDevRoleTestEnabled = localStorage.getItem('dev_role_test_enabled') === 'true'
    if (!isDevRoleTestEnabled) {
      console.log('开发环境：跳过路由守卫认证检查（未启用角色测试）')
      next()
      return
    }
  }

  // 检查路由是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      // 检查登录状态
      const isLoggedIn = await authService.checkLoginStatus();
      if (!isLoggedIn) {
        // 如果未登录，跳转到登录页
        authService.redirectToLogin(window.location.href);
        return;
      }

      // 登录后检查用户是否有系统后台内的角色
      // 使用sessionStorage缓存检查结果，避免重复检查
      const roleCheckedKey = 'role_checked'
      const roleChecked = sessionStorage.getItem(roleCheckedKey)
      
      if (!roleChecked) {
        const hasRole = await authService.checkRole();
        if (!hasRole) {
          // 如果没有角色，显示提示并阻止进入
          Message.error('您暂无系统后台权限，请联系管理员授权');
          // 清除token，跳转到登录页
          authService.clearToken();
          authService.redirectToLogin(window.location.href);
          return;
        }
        // 标记已检查
        sessionStorage.setItem(roleCheckedKey, 'true')
      }
    } catch (error) {
      console.error('路由守卫认证检查失败:', error);
      // 如果检查失败，也跳转到登录页
      authService.redirectToLogin(window.location.href);
      return;
    }
  }
  
  next();
});

export default router
